<template>
  <div class="loginView">
    <div class="loginContent" id="login">
      <img :src="icon"/>
      <div class="tips">新零售LED汽车照明品牌</div>
      <div class="data">
        <div class="dr container">
            <input type="tel" maxlength="11" v-model="userPhone" placeholder="请输入手机号码"
                   onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))">
        </div>
        <div class="dr randCode container" v-show="loginByRand">
          <input v-model="randCode" type="number" placeholder="请输入验证码" @keyup.enter="submit()">
          <send-btn class="sendBtn" :user-phone="userPhone" rand-type="BBS_LOGIN"></send-btn>
        </div>
        <div class="dr container" v-show="!loginByRand">
          <input v-model="passWord" type="password" placeholder="请输入密码" @keyup.enter="submit()"/>
        </div>
        <div class="container">
          <div class="loginType">
            <input type="checkbox" v-model="loginByRand"/><span>验证码登录</span>
          </div>
          <router-link to="/forgotPassword">
            <span class="wj">忘记密码</span>
          </router-link>
        </div>
      </div>
      <div>
        <div class="submitBtn" @click="submit()">登录</div>
        <router-link to="/register">
          <div class="lp">注册</div>
        </router-link>
      </div>
      <div class="other">
        <p>其他方式登录</p>
      </div>
      <div class="fast_login">
        <div class="wx" @click="Wx()">
          <i class="iconfont icon-weixin-copy"></i>
          <p>微信</p>
        </div>
        <div class="qq">
          <i class="iconfont icon-qq"></i>
          <p>QQ</p>
        </div>
      </div>
    </div>
    <div class="loginFoot">
      <div>广州市中渠传媒广告有限公司 版权所有</div>
      <div><a href="https://beian.miit.gov.cn">粤ICP备12059610号-3</a></div>
      <div>
        <img class="beiAn" :src="beiAn"/>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011102001129" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44011102001129号</p></a>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from '../../common/js/types'
import sendBtn from '../common/sendBtn.vue'
export default {
  components: {
    sendBtn
  },
  name: 'login',
  data () {
    return {
      icon: require('../../assets/icon/logo.png'),
      beiAn: require('../../assets/image/beian.png'),
      loginByRand: false,
      userPhone: '',
      randCode: '',
      userName: '',
      passWord: ''
    }
  },
  computed: {
  },
  mounted: function (s) {
    if (this.$route.params && this.$route.params.redirect) {
      localStorage.redirect = this.$route.params.redirect
    }
  },
  methods: {
    Wx () {
      window.location = 'https://open.weixin.qq.com/connect/qrconnect?appid=wxfdbe3fc561a03dfd&redirect_uri=http%3A%2F%2Fautoled.com.cn%2F%23%2FaccountAssociated' + window.location.pathname.substr(1) + '&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect'
    },
    back: function () {
      this.$router.go(-1)
    },
    submit: function () {
      let that = this
      that.loading = true
      that.axios.post('/login', {
        userPhone: that.userPhone,
        randCode: that.randCode,
        passWord: that.passWord,
        loginByRand: that.loginByRand
      }, {
        emulateJSON: true
      }).then(function (response) {
        that.loading = false
        if (response.data.status === 0) {
          that.$store.commit(types.LOGIN, response.data.value)
          that.$store.commit('setToastMsg', '登录成功')
          that.axios.post('/cart/list', {
            userId: that.$root.getUserId()
          }, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            emulateJSON: true// 需要转json
          }).then(function (response) {
            if (response.data.status === 0) {
              localStorage.setItem('c', response.data.value.length)
              if (localStorage.redirect) {
                let redirect = decodeURIComponent(localStorage.redirect || '/')
                localStorage.redirect = ''
                that.$router.push({
                  path: redirect
                })
              } else {
                console.log('后退')
                that.$router.go(-1)
              }
            } else {
              that.$store.commit('setToastMsg', response.data.msg)
            }
          }).catch(function (response) {
            that.$store.commit('setToastMsg', '网络错误')
          })
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        console.log(response)
        that.loading = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  },
  filters: {
  }
}
</script>
<style scoped>
.loginView{
  background-color: #FBFBFB;
  padding-bottom: 20px;
  border-top: 1px solid #F0F0F0;
  padding-top: 110px;
}
.loginContent {
  width: 300px;
  margin: 0 auto;
}
.tips {
  font-size: 16px;
  margin: 27px 0 64px 0;
}
.data{
  text-align: center;
  width: 300px;
  font-size: 18px;
}
.data .dr {
  width: 300px;
  margin-bottom: 17px;
}
.data .dr input{
 height: 40px;
 width: 100%;
 outline: 0;
 font-size: 14px;
 text-indent: 1em;
 border: 1px solid #F0F0F0;
}
.randCode input{
  width: 150px !important;
  float: left;
}
.loginType {
  margin-left: 10px;
  font-size: 12px;
  float: left;
  display: flex;
  align-items: center;
}
.wj {
  color: #06B570;
  font-weight: 600;
  font-size: 12px;
  margin-right: 10px;
  float: right;
}
.submitBtn{
  margin: 25px 0 17px 0;
  font-size: 20px;
  background-color: #06B570;
  color: white;
  height: 40px;
  line-height: 40px;
  width: 300px;
}
.lp {
  font-size: 20px;
  height: 40px;
  line-height: 40px;
  background-color: #FFFFFF;
  width: 300px;
  border: 1px solid #F0F0F0;
}
.loginFoot {
  font-size: 12px;
  width: 600px;
  margin: 0 auto;
  margin-top: 160px;
  padding-bottom: 20px;
}
.loginFoot div {
  float: left;
  padding: 0 10px;
}
.beiAn{
  vertical-align: top;
}
/*----------------其他登录-------------*/
.other{
  width: 100%;
  height: 1px;
  border-bottom: 1px solid #ccc;
  position: relative;
  margin-top: 80px;
}
.other p{
  width: 120px;
  height: 20px;
  position: absolute;
  left: 50%;
  margin-left: -60px;
  margin-top: -8px;
  background-color: #fbfbfb;
  font-size: 16px;
  color: #878b8a;
}
.fast_login{
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 40px;
}
.fast_login .icon-weixin-copy{
  font-size: 40px;
  color: #06B570;
  display: block;
  }
.fast_login .icon-qq{
  font-size: 40px;
  color: #7dc5eb;
  display: block;
}
.wx,
.qq{
  cursor: pointer;
}
.fast_login p{
  font-size: 12px;
  margin-top: 3px;
  color: #333;
  font-family: 'Microsoft YaHei' !important;
}
</style>
<style>
  #login .sendBtn{
    width: 116px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    margin: 0;
    margin-left: 17px;
    background-color: #06B570;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/login.vue